export function extractI18nMessages (messages, prefix = '') {
  const fmtPrefix = `${prefix}_`
  const COOKIE_CONSENT_REGEX = new RegExp(`^${fmtPrefix}*`)
  return Object.keys(messages)
    .filter(k => COOKIE_CONSENT_REGEX.test(k))
    .reduce((translations, k) => {
      if (!k) return translations
      const formattedKey = k.replace(fmtPrefix, '').toLowerCase()
      return {
        ...translations,
        [formattedKey]: messages[k]
      }
    }, {})
}
